import React from 'react';
import { Container } from 'react-bootstrap';

const Footer: React.FC = () => {
  return (
    <footer className="app-footer">
      <Container className="text-center">
        <p className="mb-0">&copy; {new Date().getFullYear()} Ashridge Park Football Club. All rights reserved.</p>
      </Container>
    </footer>
  );
};

export default Footer;